// Bootstrap. Login is REQUIRED: this entry point mounts ONLY the auth gate. The rest of the app
// (./app — the chart, panels, ops, everything that sets window.seabearing) is dynamically imported
// and mounted only once a session exists, so an unauthenticated visitor genuinely cannot use it.
import './style.css';
import { AuthGate } from './ui/authGate';
import { captureFriendLink } from './social/friendLink';

try {
  const vk = (navigator as Navigator & { virtualKeyboard?: { overlaysContent: boolean } }).virtualKeyboard;
  if (vk) vk.overlaysContent = true;
} catch { /* unsupported or refused */ }

// A friend link (…/?friend=<token>) is lifted into localStorage BEFORE the login wall, so it survives
// sign-in — including a magic-link / OAuth round trip, which returns without the query string.
captureFriendLink();

// The dynamic import's module-eval side effects build and mount the whole app; the gate imports it
// once, and shows a failure to load (ui/authGate.ts).
const gate = new AuthGate(() => import('./app').then(() => undefined));
document.body.append(gate.root);
